import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const PORTAL_API = `${BASE}/api`;

const portalClient = axios.create({ baseURL: PORTAL_API });

portalClient.interceptors.request.use((cfg) => {
    const t = localStorage.getItem("forge_portal_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

portalClient.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("forge_portal_token");
            localStorage.removeItem("forge_portal_user");
            if (!window.location.pathname.startsWith("/portal/login") &&
                !window.location.pathname.startsWith("/portal/redeem")) {
                window.location.href = "/portal/login";
            }
        }
        return Promise.reject(err);
    }
);

export default portalClient;
